import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthenticationRoleRequest, AuthenticationRoleResponse, MultiTokenUser } from '@jms/model';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { loginAuthorisedAction, shellLoginAction, shellLoginFailedAction, shellLoginSuccessAction, shellLogoutAction } from './shell.actions';

@Injectable()
export class ShellEffects {
    private searchURL = '/send/search';
    constructor(
        private http: HttpClient,
        private actions$: Actions,
        private router: Router) {
    }


    public loginAction$ = createEffect(() => this.actions$
        .pipe(
            ofType(shellLoginAction),
            switchMap(action => {
                return this.http.post<AuthenticationRoleResponse>(`/api/authentication/login/outlook`, action.login)
                    .pipe(
                        map(x => {

                            if (!x || !x.success) {
                                return shellLoginFailedAction({ message: 'Invalid username or password' });
                            }

                            const user = x.token
                                ? new JwtHelperService({}).decodeToken(x.token)
                                : null;

                            return shellLoginSuccessAction({ user: user as any, token: x.token, returnUrl: this.getSendDefaultURL(action.returnUrl, user) });

                        }),
                        catchError((error) => {
                            console.log(error);
                            return of(shellLoginFailedAction({ message: error }));
                        })
                    );
            })
        ));

    public loginAuthorised$ = createEffect(() => this.actions$
        .pipe(
            ofType(loginAuthorisedAction),
            switchMap(x => {

                if (!x.token) {
                    return of(shellLoginFailedAction({ message: 'No token provided' }));
                }

                return this.http.post<AuthenticationRoleResponse>(`/api/authentication/role`, { token: x.token } as AuthenticationRoleRequest)
                    .pipe(
                        map((login: AuthenticationRoleResponse) => {
                            if (!login.success) {
                                return shellLoginFailedAction({ message: 'Invalid token' });
                            }

                            const user = login.token
                                ? new JwtHelperService({}).decodeToken(login.token)
                                : null;

                            return shellLoginSuccessAction({ user: user as any, token: login.token, returnUrl: this.getSendDefaultURL(x.returnUrl, user) });
                        }),
                        catchError((error) => {
                            console.log(error);
                            return of(shellLoginFailedAction({ message: error }));
                        })
                    );
            })
        ));

    public loginSuccess$ = createEffect(() => this.actions$
        .pipe(
            ofType(shellLoginSuccessAction),
            tap(action => {
                const sendUrl = this.getSendDefaultURL(action.returnUrl, action.user);

                this.router.navigate([sendUrl]);
            })
        ), { dispatch: false });

    public logoutAction$ = createEffect(() => this.actions$
        .pipe(
            ofType(shellLogoutAction),
            tap(_ => {
                this.router.navigate(["login"]);
            })
        ), { dispatch: false });

    private getSendDefaultURL(url: string, user: MultiTokenUser): string {

        const tenantsLength = user.tenants ? user.tenants.length : 0;

        if (tenantsLength === 1) {
            return this.searchURL;
        }

        return url;
    }
}
